import { render, staticRenderFns } from "./previewWindow.vue?vue&type=template&id=263b47d6&scoped=true"
import script from "./previewWindow.vue?vue&type=script&lang=js"
export * from "./previewWindow.vue?vue&type=script&lang=js"
import style0 from "./previewWindow.vue?vue&type=style&index=0&id=263b47d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b47d6",
  null
  
)

export default component.exports